import { render, staticRenderFns } from "./spec-games-item.vue?vue&type=template&id=0e70d568&scoped=true&"
import script from "./spec-games-item.vue?vue&type=script&lang=js&"
export * from "./spec-games-item.vue?vue&type=script&lang=js&"
import style0 from "./spec-games-item.vue?vue&type=style&index=0&id=0e70d568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e70d568",
  null
  
)

export default component.exports